import { render, staticRenderFns } from "./UserManagementDetail.vue?vue&type=template&id=0fd018d2&"
import script from "./UserManagementDetail.vue?vue&type=script&lang=js&"
export * from "./UserManagementDetail.vue?vue&type=script&lang=js&"
import style0 from "./UserManagementDetail.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/views/UserManagementDetail.vue
// module id = null
// module chunks = 